import React from 'react';
import {
  BusyRecord,
  BusyRecordsType,
  busyRecordsMessage,
} from '../busyRecords';

type BusyRecordsBannerProps = {
  records: BusyRecord[];
  type?: BusyRecordsType;
};

/**
 * Shown on the legacy conversion and audience pages while the new editor has
 * a record in progress (RGI-2618). The page stays readable; Publish and
 * Delete are disabled next to it.
 */
export default function BusyRecordsBanner({
  records,
  type = 'conversions',
}: BusyRecordsBannerProps) {
  if (!records.length) return null;

  return (
    <div
      className="alert alert-warning box-shadow-3d alert-No-Data"
      role="alert"
      data-testid="busy-records-banner"
    >
      <p className="mb-0">{busyRecordsMessage(records, type)}</p>
    </div>
  );
}
